import { render } from "./NewQuestionDialog.vue?vue&type=template&id=1f72123b&scoped=true"
import script from "./NewQuestionDialog.vue?vue&type=script&lang=js"
export * from "./NewQuestionDialog.vue?vue&type=script&lang=js"

import "./NewQuestionDialog.vue?vue&type=style&index=0&id=1f72123b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f72123b"]])

export default __exports__